<template>
  <div class="fe-spacing-vertical">
    <RatingTitle />
    <div>
      <div>
        <div class="fe-mb-xl">
          <RatingSummary />
        </div>
        <div>
          <RatingCta />
        </div>
      </div>

      <div>
        <MyReviewList class="fe-mb-m" />
        <GalleryList class="fe-mb-m" />

        <div>
          <ReviewList />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RatingSummary from "@/components/ReviewAndRating/RatingSummary/RatingSummary.two.vue"
  import RatingCta from "@/components/ReviewAndRating/RatingCta/RatingCta.two.vue"
  import GalleryList from "@/components/ReviewAndRating/Gallery/GalleryList.vue"
  import ReviewList from "@/components/ReviewAndRating/ReviewList/ReviewList.vue"
  import MyReviewList from "@/components/ReviewAndRating/ReviewList/MyReviewList.vue"
  import RatingTitle from "@/components/ReviewAndRating/RatingTitle/RatingTitle.two.vue"

  export default {
    name: "LayoutOneDesktop",
    components: {
      RatingSummary,
      RatingCta,
      MyReviewList,
      ReviewList,
      GalleryList,
      RatingTitle,
    },
  }
</script>
